(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blinker-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blinker-guide')) {
    customElements.define('blinker-guide', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.initialize());
      }
      initialize() {
        if (this.dataset.initialized) return;
        const content = this.querySelector('[data-guide-content]');
        const more = this.querySelector('[data-guide-more]');
        const button = this.querySelector('button');
        if (!content || !more || !button) return;
        this.dataset.initialized = 'true';
        const children = Array.from(content.children);
        if (content.textContent.trim().length <= 650 || children.length < 3) return;
        const nextHeading = children.findIndex((child, index) => index > 0 && /^H[2-6]$/.test(child.tagName));
        const splitIndex = nextHeading > 0 ? nextHeading : 2;
        if (splitIndex >= children.length) return;
        Array.from(content.childNodes).slice(Array.from(content.childNodes).indexOf(children[splitIndex])).forEach(node => more.appendChild(node));
        button.hidden = false;
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          more.hidden = !expanded;
          button.setAttribute('aria-expanded', String(expanded));
          button.querySelector('[data-more]').hidden = expanded;
          button.querySelector('[data-less]').hidden = !expanded;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('service-video-gallery')) {
    customElements.define('service-video-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.onMediaEvent) return;
        this.onMediaEvent = (event) => {
          if (!(event.target instanceof HTMLVideoElement)) return;
          if (event.type === 'play') {
            document.querySelectorAll('service-video-gallery video').forEach((video) => {
              if (video !== event.target) video.pause();
            });
          }
          this.updateControl(event.target);
          if (event.type === 'error') this.showError(event.target);
        };
        this.onToggleClick = async (event) => {
          const button = event.target.closest('.service-videos__toggle');
          if (!button || !this.contains(button)) return;
          const media = button.closest('.service-videos__media');
          const video = media.querySelector('video');
          if (!video) return;
          media.querySelector('.service-videos__error').hidden = true;
          if (!video.paused && !video.ended) {
            video.pause();
            return;
          }
          button.disabled = true;
          try {
            if (video.error) video.load();
            await video.play();
          } catch (error) {
            if (error.name !== 'AbortError') this.showError(video);
          } finally {
            button.disabled = false;
            this.updateControl(video);
          }
        };
        ['play', 'pause', 'ended', 'error'].forEach((type) => {
          this.addEventListener(type, this.onMediaEvent, { capture: true });
        });
        this.addEventListener('click', this.onToggleClick);
        this.querySelectorAll('video').forEach((video) => {
          video.controls = false;
          this.updateControl(video);
          if (video.error) this.showError(video);
        });
      }
      updateControl(video) {
        const media = video.closest('.service-videos__media');
        const button = media.querySelector('.service-videos__toggle');
        const playing = !video.paused && !video.ended;
        media.dataset.playing = String(playing);
        button.hidden = false;
        button.disabled = false;
        button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      }
      showError(video) {
        video.closest('.service-videos__media').querySelector('.service-videos__error').hidden = false;
      }
      disconnectedCallback() {
        ['play', 'pause', 'ended', 'error'].forEach((type) => {
          this.removeEventListener(type, this.onMediaEvent, { capture: true });
        });
        this.removeEventListener('click', this.onToggleClick);
        this.onMediaEvent = null;
        this.onToggleClick = null;
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
